// extracted by mini-css-extract-plugin
export default {"captcha":"styles_captcha__uLOc9","refresh":"styles_refresh__0eqFh"};